import React, { useState, useEffect } from 'react'
import {
  Box,
  Typography,
  Container,
  CircularProgress,
  Alert,
  Dialog,
  DialogContent
} from '@mui/material'
import RealtorDetail from '../components/RealtorDetail'
import { type RealtorData } from '../components/RealtorCard'
import { useContentByEmbed } from '../hooks/useContentByEmbed'

export interface FeaturedAgentsDetailProps {
  embedId: string
  encriptedString: string
  onClose?: () => void
  onContact?: (realtor: RealtorData) => void
}

const FeaturedAgentsDetail: React.FC<FeaturedAgentsDetailProps> = ({
  embedId,
                                                                     encriptedString,
  onClose,
  onContact
}) => {
  const [selectedRealtor, setSelectedRealtor] = useState<RealtorData | null>(null)

  // Fetch data using the hook
  const { 
    data: contentData, 
    isLoading: isLoadingContent, 
    error: contentError
  } = useContentByEmbed(embedId, encriptedString)

  useEffect(() => {
    console.log('FeaturedAgentsDetail contentData', contentData)
  }, [contentData])

  // Transform data from API to RealtorData format
  useEffect(() => {
    if (contentData?.data?.data && Array.isArray(contentData.data.data) && contentData.data.data.length > 0) {
      const realtorItem = contentData.data.data[0] // Tomar el primer elemento del array
      const transformedRealtor: RealtorData = {
        id: realtorItem.id?.toString() || '',
        image: realtorItem.data?.photo || 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop',
        name: realtorItem.data?.fullName?.trim() || 'Agent Name',
        title: realtorItem.data?.role || 'REALTOR',
        description: realtorItem.data?.shortDescription || realtorItem.data?.longDescription || '',
        phone: realtorItem.data?.phone || '(555) 123-4567',
        email: realtorItem.data?.email || 'agent@example.com',
        url: realtorItem.data?.url || realtorItem.data?.website || realtorItem.data?.profileUrl
      }
      setSelectedRealtor(transformedRealtor)
    } else {
      console.log('No contentData received or empty array')
      setSelectedRealtor(null)
    }
  }, [contentData])

  const handleCloseDetail = () => {
    setSelectedRealtor(null)
    onClose?.()
  }

  const handleContact = (realtor: RealtorData) => {
    onContact?.(realtor)
  }

  if (isLoadingContent) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
          <CircularProgress size={60} />
        </Box>
      </Container>
    )
  }

  if (contentError) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ fontSize: '1rem' }}>
          Error al cargar el agente: {contentError.message}
        </Alert>
      </Container>
    )
  }

  if (!selectedRealtor) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="warning" sx={{ fontSize: '1rem' }}>
          Agente no encontrado
        </Alert>
      </Container>
    )
  }

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        fontFamily: 'Montserrat, sans-serif',
      }}
    >
      <Container maxWidth="lg">
        <RealtorDetail
          data={selectedRealtor}
          onContact={handleContact}
          onClose={handleCloseDetail}
        />
      </Container>
    </Box>
  )
}

export default FeaturedAgentsDetail
